<h5>Tarefas para remuneração</h5>
 <div class="alert alert-warning p-1 mb-1" role="alert">
    ⚠️ As cotações da SELIC D-2 (UM 143) estão carregadas até {{ dataUltimaCotacaoSelic }} neste ambiente. Se necessário, solicite à TI a atualização das cotações.
</div>

<div class="container">
  <div ngbAccordion #acc="ngbAccordion">
    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">
                Central de Remuneração - Solicitação individual
            </button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning p-1 mb-1" role="alert">
                                ⚠️ Remunerações de operações de Repasse do SCC podem levar de 1 a 4 minutos, em virtude de integração com o Mainframe.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label for="idSh">Id Operação:</label>
                            <input type="text" id="idSh" class="form-control" bnMask="INTEIRO" [(ngModel)]="central.ideOperacaoGarantida" (blur)="onIdOperacaoBlur()">
                        </div>

                        <div class="col-md-2">
                            <label for="valor">Valor:</label>
                            <input
                                type="text"
                                id="valor"
                                class="form-control"
                                bnMask="MOEDA"
                                [(ngModel)]="central.valorEmReaisASerRemunerado" required
                            />
                        </div>

                        <div class="col-md-3">
                            <label for="dataInicial">Data Inicial:</label>
                            <bn-datepicker
                                id="dataInicial"
                                ngDefaultControl
                                [(ngModel)]="central.dataInicioRemuneracao" required
                            >
                            </bn-datepicker>
                        </div>

                        <div class="col-md-3">
                            <label for="dataFinal">Data Final:</label>
                            <bn-datepicker
                                id="dataFinal"
                                ngDefaultControl
                                [(ngModel)]="central.dataFimRemuneracao" required
                            >
                            </bn-datepicker>
                        </div>
                        <div class="col-md-2">
                            <div class="form-check">
                                <label for="checkFator">Cálculo por fator?</label>
                                <input type="checkbox" class="form-check checkbox-gigante" id="checkFator" [(ngModel)]="central.remuneracaoPorFatores">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <label for="resultado">Resultado:</label>
                            <input
                                type="text"
                                id="resultado"
                                class="form-control"
                                disabled
                                [value]="central.resultado | bnMask: 'MOEDA.6'"
                            />
                        </div>
                        <div class="col-md-9">
                            <label for="descricao">Detalhes:</label>
                            <input
                                type="text"
                                id="descricao"
                                class="form-control"
                                disabled
                                [(ngModel)]="central.descricaoTaxaAtualizacao"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" class="btn btn-success no-margin" (click)="remunerarPorCentralRemuneracao()" [disabled]="camposNaoPreenchidosSolicitacaoPorCentral">
                                Calcular
                            </button>
                        </div>

                        <div class="submit col-auto">
                            <button type="button" class="btn btn-light" (click)="limparCentral()">
                                Limpar
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">
                Remunerador - Crédito Livre
            </button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label id="ideIndexadorSelecionado">Indexador:</label>
                            <select
                                id="ideIndexadorSelecionado"
                                class="form-select"
                                [(ngModel)]="credito.ideIndexadorAtualizacaoGarantia"
                                required
                            >
                                <option *ngFor="let item of indexadores" [value]="item.id">
                                    {{ item.nome }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="dataInicial">Data Inicial:</label>
                            <bn-datepicker
                                id="dataInicial"
                                ngDefaultControl
                                [(ngModel)]="credito.dataInicial" required
                            >
                            </bn-datepicker>
                        </div>

                        <div class="col-md-3">
                            <label for="dataFinal">Data Final:</label>
                            <bn-datepicker
                                id="dataFinal"
                                ngDefaultControl
                                [(ngModel)]="credito.dataFinal" required
                            >
                            </bn-datepicker>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <label for="valorOperacao">Valor:</label>
                            <input
                                type="text"
                                id="valorOperacao"
                                class="form-control"
                                bnMask="MOEDA"
                                [(ngModel)]="credito.valorOperacao" required
                            />
                        </div>

                        <div class="col-md-3">
                            <label for="valorTaxaAdicional">Taxa Adicional:</label>
                            <input
                                type="text"
                                id="valorTaxaAdicional"
                                class="form-control"
                                bnMask="DECIMAL" [casasDecimais]="2"
                                [(ngModel)]="credito.valorTaxaAdicional"
                            />
                        </div>

                        <div class="col-md-3">
                            <label for="resultado">Resultado:</label>
                            <input
                                type="text"
                                id="resultado"
                                class="form-control"
                                disabled
                                [value]="credito.resultado | bnMask: 'MOEDA'"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" class="btn btn-success no-margin" (click)="remunerarCreditoLivre()" [disabled]="camposNaoPreenchidos">
                                Calcular
                            </button>
                        </div>

                        <div class="submit col-auto">
                            <button type="button" class="btn btn-light" (click)="limparCreditoLivre()">
                                Limpar
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">
                Remunerador - Repasse
            </button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                         <div class="col-1">
                            <label>Sistema:</label>
                            <select class="form-select" [(ngModel)]="repasse.numeroSistemaScc">
                                <option value=""></option>
                                <option value="15">15</option>
                                <option value="89">89</option>
                            </select>
                        </div>
                        <div class="col-2">
                            <label>Contrato:</label>
                            <input type="text" class="form-control" [(ngModel)]="repasse.numeroContratoScc" bnMask="CONTRATO">
                        </div>
                        <div class="col-2">
                            <label>Valor:</label>
                            <input type="text" class="form-control" [(ngModel)]="repasse.valorARemunerar" bnMask="MOEDA">
                        </div>
                        <div class="col-3">
                            <label>Data Inicial:</label>
                            <bn-datepicker [(ngModel)]="repasse.dataInicial" ngDefaultControl></bn-datepicker>
                        </div>
                        <div class="col-3">
                            <label>Data Final:</label>
                            <bn-datepicker [(ngModel)]="repasse.dataFinal" ngDefaultControl></bn-datepicker>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-3">
                            <label for="resultado">Resultado:</label>
                            <input
                                type="text"
                                id="resultado"
                                class="form-control"
                                disabled
                                [value]="repasse.resultado?.valorRemunerado | bnMask: 'MOEDA'"
                            />
                        </div>
                        <div class="col-md-8">
                            <label for="descricao">Detalhes:</label>
                            <input
                                type="text"
                                id="descricao"
                                class="form-control"
                                disabled
                                [value]="repasse.resultado?.detalhesRemuneracao"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" class="btn btn-success no-margin" (click)="remunerarRepasse()" [disabled]="camposNaoPreenchidosRepasse">
                                Calcular
                            </button>
                        </div>

                        <div class="submit col-auto">
                            <button type="button" class="btn btn-light" (click)="limparRepasse()">
                                Limpar
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">
                Habilitar/Desabilitar Remuneração
            </button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" class="btn btn-success no-margin" (click)="habilitar()">
                                Habilitar
                            </button>
                        </div>

                        <div class="submit col-auto">
                            <button type="button" class="btn btn-danger no-margin" (click)="desabilitar()">
                                Desabilitar
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
  </div>
</div>
